import { render, staticRenderFns } from "./ChangeProductReceive.vue?vue&type=template&id=3645a7d8&scoped=true&"
import script from "./ChangeProductReceive.vue?vue&type=script&lang=ts&"
export * from "./ChangeProductReceive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3645a7d8",
  null
  
)

export default component.exports